// src/index.tsx

import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { QuoteProvider } from "./context/QuoteContext";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n"; // 确保您已正确配置 i18n

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <QuoteProvider>
        <App />
      </QuoteProvider>
    </I18nextProvider>
  </React.StrictMode>
);
